import { useCallback, useMemo } from "react"


export default function useApi() {
  const requestConfig = useMemo(() => {
    return {
      method: "POST",
      redirect: "follow",
      mode: "cors",
      cache: "default",
    }

  }, [])


  const sendRequest = useCallback((path, method = 'POST') => {
    const host = process.env.REACT_APP_BASE_URL;
    const url = `${host}${path}`
    const config = {
      ...requestConfig, method
    }
    const request = new Request(url, config)
    return fetch(request).then(async function (response) {
      if (response.ok && response.status !== 201) {
        const result = await response.text()
        return JSON.parse(result)
      }
      return response
    }).catch(e => {
      console.error(e)
    })
  }, [requestConfig])

  return { sendRequest }
}
